"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _uuid = require("uuid");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _MultiInput = _interopRequireDefault(require("./MultiInput"));
var _Select = _interopRequireDefault(require("./Select.style"));
var _InputError = _interopRequireDefault(require("../errors/InputError"));
var _SelectedItem = _interopRequireDefault(require("./SelectedItem"));
var _tooltip = require("../tooltip");
var _helpers = require("./helpers");
var _excluded = ["ariaLabel", "errors", "disableUnderline", "value", "onChange", "id", "optionClassName", "multi", "createable", "labelKey", "placeholder"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Select = function Select(_ref) {
  var ariaLabel = _ref.ariaLabel,
    errors = _ref.errors,
    disableUnderline = _ref.disableUnderline,
    value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    optionClassName = _ref.optionClassName,
    multi = _ref.multi,
    createable = _ref.createable,
    labelKey = _ref.labelKey,
    placeholder = _ref.placeholder,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var multiProps = null;
  var newId = R.isEmpty(id) ? (0, _uuid.v4)() : id;
  if (multi) {
    multiProps = {
      multi: multi,
      closeOnSelect: false,
      searchable: true,
      valueComponent: _SelectedItem["default"],
      backspaceRemoves: true,
      deleteRemoves: true
    };
  }
  var renderIcon = function renderIcon() {
    return /*#__PURE__*/_react["default"].createElement("i", {
      className: "icon icon-ion-chevron-down"
    });
  };
  var renderValue = function renderValue(_ref2) {
    var vl = _ref2.vl;
    var selectedLabel = (0, _helpers.getSelectedValueLabel)(vl, labelKey);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
      id: "tip-".concat(newId)
    }), /*#__PURE__*/_react["default"].createElement("span", {
      "data-tip": selectedLabel,
      "data-for": "tip-".concat(newId),
      "data-place": "top"
    }, selectedLabel));
  };
  return /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    className: "select-wrapper",
    "data-testid": "select-wrapper"
  }, createable ? /*#__PURE__*/_react["default"].createElement(_MultiInput["default"], _extends({
    value: value,
    onChange: onChange,
    placeholder: placeholder
  }, otherProps, multiProps)) : /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({
    autoComplete: "off",
    optionClassName: optionClassName,
    disableUnderline: disableUnderline,
    arrowRenderer: renderIcon,
    value: value,
    onChange: onChange,
    backspaceRemoves: false,
    deleteRemoves: false,
    "aria-label": ariaLabel || placeholder,
    placeholder: placeholder,
    clearable: false,
    instanceId: newId,
    errors: errors,
    matchProp: "label",
    inputProps: {
      autoComplete: 'off'
    },
    labelKey: labelKey,
    valueRenderer: function valueRenderer(vl) {
      return renderValue({
        vl: vl
      });
    },
    id: newId,
    className: newId
  }, multiProps, otherProps)), errors && (Array.isArray(errors) ? errors.map(function (error) {
    return /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
      key: "".concat(error),
      message: error
    });
  }) : /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    message: errors,
    id: "".concat(id, "Error")
  })));
};
Select.defaultProps = {
  createable: false,
  errors: null,
  disableUnderline: false,
  optionClassName: '',
  value: null,
  ariaLabel: null,
  multi: false,
  id: '',
  labelKey: 'label',
  placeholder: ''
};
Select.propTypes = {
  labelKey: _propTypes["default"].string,
  createable: _propTypes["default"].bool,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /**
   * If `true` hides the bottom border of the input/
   */
  disableUnderline: _propTypes["default"].bool,
  // eslint-disable-next-line react/forbid-prop-types
  value: _propTypes["default"].any,
  ariaLabel: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string,
  optionClassName: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  multi: _propTypes["default"].bool
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Select);